/*
 * GET PAYMENT_METHODS
*/
export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS';
export const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
export const GET_PAYMENT_METHODS_ERROR = 'GET_PAYMENT_METHODS_ERROR';

/*
 * INITIATE CARD UPDATE
*/
export const INITIATE_CARD_UPDATE = 'INITIATE_CARD_UPDATE';
export const INITIATE_CARD_UPDATE_SUCCESS = 'INITIATE_CARD_UPDATE_SUCCESS';
export const INITIATE_CARD_UPDATE_ERROR = 'INITIATE_CARD_UPDATE_ERROR';

/* COMPLETE CARD UPDATE
*/
export const COMPLETE_CARD_UPDATE = 'COMPLETE_CARD_UPDATE';
export const COMPLETE_CARD_UPDATE_SUCCESS = 'COMPLETE_CARD_UPDATE_SUCCESS';
export const COMPLETE_CARD_UPDATE_ERROR = 'COMPLETE_CARD_UPDATE_ERROR';

/* COMPLETE CARD_2 UPDATE
*/
export const COMPLETE_CARD_UPDATE_2 = 'COMPLETE_CARD_UPDATE_2';
export const COMPLETE_CARD_UPDATE_2_SUCCESS = 'COMPLETE_CARD_UPDATE_SUCCESS_2';
export const COMPLETE_CARD_UPDATE_2_ERROR = 'COMPLETE_CARD_UPDATE_ERROR_2';

/* CANCEL CARD UPDATE
*/
export const CANCEL_CARD_UPDATE = 'CANCEL_CARD_UPDATE';
export const CANCEL_CARD_UPDATE_SUCCESS = 'CANCEL_CARD_UPDATE_SUCCESS';
export const CANCEL_CARD_UPDATE_ERROR = 'CANCEL_CARD_UPDATE_ERROR';

/* GET_BILLING_REPORT
*/
export const GET_BILLING_REPORT = 'GET_BILLING_REPORT';
export const GET_BILLING_REPORT_SUCCESS = 'GET_BILLING_REPORT_SUCCESS';
export const GET_BILLING_REPORT_ERROR = 'GET_BILLING_REPORT_ERROR';
